"use client";

import { useEffect, useRef } from "react";

import { useAuthStore } from "@/shared/model/auth-store";
import { useUserProfile } from "@/hooks/useAuth";
import { updateUserStatusViaSignalR } from "@/shared/lib/signalr-helpers";
import { useUserActivity } from "@/shared/lib/hooks/use-user-activity";

type UserStatus = "online" | "offline" | "playing" | "busy" | "away" | "searching";

export function ActivityStatusSync() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { data: user, refetch: refetchUser } = useUserProfile();

  const previousStatusRef = useRef<UserStatus>(
    (user?.status as UserStatus) || "online",
  );

  useEffect(() => {
    if (
      user?.status &&
      user.status !== "away" &&
      user.status !== "offline"
    ) {
      previousStatusRef.current = user.status as UserStatus;
    }
  }, [user?.status]);

  useUserActivity({
    onIdle: async () => {
      if (!isAuthenticated || !user) return;

      const currentStatus = (user.status || "online") as UserStatus;
      if (currentStatus === "busy" || currentStatus === "playing" || currentStatus === "searching") return;

      if (currentStatus !== "offline" && currentStatus !== "away") {
        previousStatusRef.current = currentStatus;
        const ok = await updateUserStatusViaSignalR("away");
        if (ok) await refetchUser();
      }
    },
    onActive: async () => {
      if (!isAuthenticated || !user) return;

      const restore = previousStatusRef.current;
      if (user.status === "away" && restore !== "away") {
        const ok = await updateUserStatusViaSignalR(restore);
        if (ok) await refetchUser();
      }
    },
    idleTimeout: 5 * 60 * 1000,
  });

  return null;
}

